import { render } from "./SearchText.vue?vue&type=template&id=745a1ae7&scoped=true"
import script from "./SearchText.vue?vue&type=script&lang=js"
export * from "./SearchText.vue?vue&type=script&lang=js"

import "./SearchText.vue?vue&type=style&index=0&id=745a1ae7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745a1ae7"]])

export default __exports__